import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TSelectOption } from 'src/app/project/components/input/select/select.model';
import { GET_CUSTOM_FIELDS } from 'src/app/project/modules/custom-fields/custom-fields.store';
import { EPointSearchOperator } from 'src/app/project/modules/points/point-search/point-search.consts';
import { EAdvancedFilterOptions } from '../../../../models/advanced-filter-options.enum';
import {
  TAdvancedFilterDuration,
  TAdvancedFilterSingle,
  TFilterDurationOptions,
} from '../../../../models/advanced-filter.model';
import { durationOperatorOptions } from '../../../../utils/advanced-filter-operator.utils';

@Component({
  selector: 'pp-advanced-filter-duration',
  templateUrl: './advanced-filter-duration.component.html',
  styleUrls: ['./advanced-filter-duration.component.scss'],
  standalone: false,
})
export class AdvancedFilterDurationComponent {
  @Input() ppFilter: TAdvancedFilterSingle;
  @Output() ppFilterChange = new EventEmitter<TAdvancedFilterSingle>();

  value: number;
  option: TFilterDurationOptions;
  filter: TAdvancedFilterDuration;
  showHoursOnly: boolean;
  shortWidth = '5.25rem';
  longWidth = '8.25rem';
  inputWidth: string;

  advancedFilterDurationOptions = durationOperatorOptions;
  EAdvancedFilterOptions = EAdvancedFilterOptions;

  ngOnChanges(): void {
    this.filter = this.ppFilter as TAdvancedFilterDuration;
    const field = GET_CUSTOM_FIELDS()[this.filter.id];

    this.value = this.filter.value as number;
    this.option = this.filter.option;

    this.showHoursOnly = field?.showHoursOnly;
    this.inputWidth = this.showHoursOnly ? this.longWidth : this.shortWidth;
  }

  changeFieldCondition(newCondition: TSelectOption): void {
    this.ppFilter.option = newCondition.value as TFilterDurationOptions;
    this.option = newCondition.value as TFilterDurationOptions;

    this.ppFilter.operator = newCondition.operator;

    if (
      this.ppFilter.option === EAdvancedFilterOptions.IS_EMPTY ||
      this.ppFilter.option === EAdvancedFilterOptions.IS_NOT_EMPTY
    ) {
      this.ppFilter.value = newCondition.data;
    }

    this.applyChanges();
  }

  applyChanges(): void {
    this.ppFilterChange.emit(this.ppFilter);
  }

  changeFieldValue(value: number): void {
    this.ppFilter.value = value;
    this.applyChanges();
  }
}
